export const RESPONSE_ERROR = 'ResponseError'

export const REQUEST_CANCEL = 'RequestCancel'



// WEBPACK FOOTER //
// ./src/apis/ajax/EventKeys.js